export default "/assets/images/purely-white.262bf20b8c4a1b1e.webp";